import React from 'react';
import './Unauthorized.css';

interface UnauthorizedProps {
    onLogin: () => void;
    message?: string;
}

const Unauthorized: React.FC<UnauthorizedProps> = ({ onLogin, message }) => {
    return (
        <div className="unauthorized-container">
            <h2>Session Expired or Unauthorized</h2>
            <p>{message || 'Your session has expired or you are not authorized. Please log in again.'}</p>
            <button className="btn btn-primary" onClick={onLogin}>
                Back to Login
            </button>
        </div>
    );
};

export default Unauthorized;
